/*
 * @Author: 朱亚
 * @Date: 2020-10-10 10:19:09
 * @说明：判断是否是微信浏览器
 */
const isWxBrowser = () => {
  let userAgent = window.navigator.userAgent.toLowerCase()
  if (userAgent.indexOf('micromessenger') > 0) {
    return true
  }
  return false
}
// 定义插件
const install = Vue => {
  Object.defineProperties(Vue.prototype, {
    $isWxBrowser: {
      get() {
        return isWxBrowser
      }
    }
  })
}
export default { install }



// WEBPACK FOOTER //
// ./src/plugins/isWxBrowser.js